const important = (style) => {
	const newStyle = {};
	Object.keys(style).forEach((key) => {
		const val = style[key];
		if (typeof val !== 'object') {
			newStyle[key] = `${val} !important`;
		} else {
			const subStyle = {};
			Object.keys(val).forEach((k) => {
				const v = val[k];
				if (typeof v !== 'object') {
					subStyle[k] = `${v} !important`;
				}
			});
			newStyle[key] = subStyle;
		}
	});
	return newStyle;
};

const shadow = () => {
	return '0 4px 8px 0 rgba(56,96,165,0.15)';
};

export { important, shadow };
